import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGameStore } from "~/state/game-store";
import { LoginPanel } from "~/ui/game/login-panel";
import { SettingsPanel } from "~/ui/game/settings-panel";
import { Button } from "~/ui/system/button";
import { MetalWrapper } from "~/ui/system/metal-wrapper";

export function TitleScreen() {
  const navigate = useNavigate();
  const setUser = useGameStore((s) => s.setUser);
  const loadUserData = useGameStore((s) => s.loadUserData);
  const gameSaves = useGameStore((s) => s.gameSaves);
  const user = useGameStore((s) => s.user);
  const openMenu = useGameStore((s) => s.openMenu);
  const setOpenMenu = useGameStore((s) => s.setOpenMenu);

  useEffect(() => {
    void loadUserData();
  }, [loadUserData]);

  const handleStartNewGame = async () => {
    if (!user) {
      setOpenMenu("login");
      return;
    }

    await navigate("/play");
  };
  const handleContinueGame = async (gameSaveId: string) => {
    if (!user) {
      setOpenMenu("login");
      return;
    }

    await navigate(`/play?game_save_id=${gameSaveId}`);
  };

  return (
    <>
      <div className="min-h-screen relative bg-gradient-to-b from-gray-900 to-black flex items-center justify-center p-4">
        <MetalWrapper
          variant="transparent"
          size="lg"
          className="w-full max-w-2xl"
        >
          <h1 className="text-5xl font-bold text-center mb-8 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 animate-pulse">
            Deep Drill Mining
          </h1>
          <div className="space-y-4">
            <Button
              onClick={handleStartNewGame}
              size="lg"
              className="w-full"
              autoFocus
            >
              New Game
            </Button>
            {gameSaves.map((gameSave) => (
              <Button
                key={gameSave.id}
                onClick={() => handleContinueGame(gameSave.id)}
                size="lg"
                className="w-full"
              >
                <span>Resume game</span>
                <br />
                <span className="text-sm">
                  ${gameSave.currency} • {gameSave.chunk_count} chunks •{" "}
                  {gameSave.last_launched_at ? "Last played" : "Created"}{" "}
                  {Intl.DateTimeFormat("en-US", {
                    dateStyle: "short",
                    timeStyle: "short",
                  }).format(
                    (gameSave.last_launched_at || gameSave.created_at).toDate(),
                  )}
                </span>
              </Button>
            ))}
            <Button
              variant="secondary"
              size="lg"
              className="w-full"
              onClick={() => setOpenMenu("settings")}
            >
              Settings
            </Button>
          </div>
        </MetalWrapper>

        {user && (
          <div className="text-gray-300 text-sm absolute bottom-4 right-4">
            Logged in as {user.username}
            <br />
            <Button onClick={() => setUser(null)}>Logout</Button>
          </div>
        )}
      </div>

      {openMenu === "settings" ? (
        <SettingsPanel backTo={null} />
      ) : openMenu === "login" ? (
        <LoginPanel />
      ) : null}
    </>
  );
}
